<template>
  <v-container mt-1>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onResetPassword">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="uid"
                      label="Email"
                      id="uid"
                      v-model="email"
                      type="uid"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 text-xs-center>
                    <v-btn type="submit" color="primary" large>
                      Reset My Password
                    </v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- {{userData}} -->
    <!-- {{authenticationError}} -->
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import router from "@/router";

export default {
  data() {
    return {
      email: "",
      loginHasError: false,
    };
  },
  computed: {
    showError () {
      return this.loginHasError && !this.password
    }
  },
  methods: {
    ...mapActions("adminUser", ["resetPassword"]),
    async onResetPassword() {
      if(!this.email) {
        alert('Please enter your Email first!')
        return
      }
      var result = await this.resetPassword(this.email)
      if(result == 'successful') {
        alert('New password was sent to your email')
      }
      else {
        alert('Sorry, we cannot reset your password, please check system admin. to reset your password.')
      }
    },
  }
};

</script>


